import { TextField } from '@mui/material';
import styled from 'styled-components';
import { MediaQuerys } from '../../../../styles/GlobalStyle';

const { desktop } =  MediaQuerys;


export const Container = styled('div')(() => {
  return {
    width: '100%',
    height: '100%',
  }
})

export const ContainerContent = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    gap: '0.85rem',
  }
})

export const CustomTextField = styled(TextField)(() => {
  return {
    width: '100%',
    '.MuiInputBase-input': {
      [desktop]: {
        fontSize: '0.85rem'
      }
    }
  }
})